export default "__VITE_ASSET__d8bc3307__"